export const config = {
    spineHeroPointer: 'Horse-',
    bgColor: 0x1a2a3d,
    maxDistance: 4000,
    finishDistance: 3250,
    moveSpeed: 30000,
    defaultSpeed: 4,

    ticksAmount: {
        placeBet: 99,
        noMoreBets: 19,
        race: 198,
        celebration: 49,
    },

    heroColors: {
        'Horse-1': '#499cf9',
        'Horse-2': '#c2b548',
        'Horse-3': '#da5138',
        'Horse-4': '#5b1ab7',
        'Horse-5': '#ea4ea5',
        'Horse-6': '#16a847',
        'Horse-7': '#f3ac24',
        'Horse-8': '#55ccbb',
    }
}
